<template>
  <div class="welfare-item">
    <a class="welfare-head" :href="itemData.linkUrl" target="_blank">
      <img :src="itemData.picUrl" alt="">
    </a>
    <div class="welfare-main">
      {{itemData.title}}
    </div>
    <div class="welfare-footer">
      <a :href="itemData.linkUrl" class="getBtn" target="_blank">
        立即领取
      </a>
    </div>
    <div class="hot-wrapper">
      <img :src="itemData.hotImg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    styleObj () {
      return {}
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin mobile {
  @media screen and (max-width: 768px) {
    @content
  }
};
@mixin tablet {
  @media screen and (min-width: 769px) {
    @content
  }
};
.welfare-item {
  flex: 1;
  box-sizing: border-box;
  margin: 0px 10px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 0px 5px #ddd;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  @include mobile() {
    flex: none;
    width: 100%;
    display: block;
    margin: 10px 0px;
  }
  &:hover {
    box-shadow: 2px 2px 10px #ddd;
  }
  .welfare-head {
    img {
      display: block;
      width: 100%;
    }
  }
  .welfare-main {
    height: 100px;
    padding: 11px 15px;
    font-size: 16px;
    color: #000;
    @include mobile() {
      height: 70px;
      font-size: 18px;
    }
  }
  .welfare-footer {
    display: flex;
    justify-content: center;
    padding: 20px 0px;
    .getBtn {
      padding: 4px 20px;
      border-radius: 14px;
      font-size: 12px;
      color: #E35A49;
      border: 1px solid #E36151;
      @include mobile() {
        padding: 6px 30px;
        font-size: 14px;
        border-radius: 16px;
      }
      &:hover {
        background: #E35A49;
        color: #ffffff;
      }
    }
  }
  .hot-wrapper {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 50px;
    height: 50px;
  }
}
</style>
